import React from 'react'
import PageHeading from '../../layout/PageHeading'
import CityCard from './components/CityLocation'
import ContactFormWithMap from './components/ContactForm'
import FeaturesSection from '../Home/components/Services'
import InstagramInfo from '../Home/components/InstagramInfo'

const Contact = () => {
    return (
        <>
            <PageHeading title={'Contact Us'} />
            <CityCard />
            <ContactFormWithMap />
            <FeaturesSection />
            {/* <InstagramInfo /> */}

        </>
    )
}

export default Contact
